import { render, staticRenderFns } from "./TaskListItem.vue?vue&type=template&id=0ab55ee5&scoped=true&"
import script from "./TaskListItem.vue?vue&type=script&lang=js&"
export * from "./TaskListItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskListItem.vue?vue&type=style&index=0&id=0ab55ee5&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab55ee5",
  null
  
)

export default component.exports